module.exports = __webpack_public_path__ + "static/img/2018.7a38a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2018.png
// module id = NCFK
// module chunks = 1